

import React, { useState, useRef, useEffect } from 'react';
import { sendEmailVerification } from "firebase/auth";
import { useAuth } from '../../Components/AuthContext/AuthContext'
import FullScreenOverlay from '../../Components/FullScreenOverlay/FullScreenOverlay';
import './inActiveUser.css'
import logout from '../../Utility/logout';

function InActiveUser() {
    const { currentUser } = useAuth();

    useEffect(() => {
        // Make sure the user is logged in and available
        if (currentUser) {
            // Call the email verification check function
            const stopChecking = checkEmailVerification();

            // Clean up the interval when the component unmounts
            return () => stopChecking();
        }
    }, [currentUser]); // Re-run only when currentUser changes


    const checkEmailVerification = () => {
        // Start an interval that runs every 2 seconds
        const interval = setInterval(async () => {
            try {
                // Reload the current user data
                await currentUser.reload();
                // const updatedUser = auth.currentUser; // Get the updated user instance

                // Check if the email is verified
                if (currentUser.emailVerified) {
                    clearInterval(interval);
                    window.location.reload()
                }
            } catch (error) {
                console.error("Error reloading user:", error);
            }
        }, 2000); // Check every 2 seconds

        // Return a cleanup function to clear the interval when needed
        return () => clearInterval(interval);
    };

    return (
        <FullScreenOverlay>
            <div className='gray_scale_1 inACtiveUser_div'>
                <div className='user_config_logout_div flex justify_center align_center' onClick={logout}>
                    <p>Logout</p>
                </div>

                <span className='font_family_inter font_size_16'>
                    To confirm your email address, please click the link below:
                    <br />
                    <br />

                    <span className='cursor_pointer green_gradient_p' onClick={() => {
                        sendEmailVerification(currentUser)
                            .then(function () {
                                // Email sent successfully
                                alert('Verification email sent successfully.')
                            })
                            .catch(function (error) {
                                // Handle errors
                                if (error.code === 'auth/too-many-requests') {
                                    // Specific handling for too many requests
                                    console.error("Too many requests. Please wait before trying again.");
                                    alert("You've made too many requests. Please wait a while before trying again.");
                                } else {
                                    // Handle other errors
                                    console.error("Error sending verification email:", error);
                                    alert("An error occurred while sending the verification email. Please try again later.");
                                }
                            });
                    }}>
                        {'Verify Your Email Address'}.
                    </span>
                    <br />
                    <br />
                    Once you click this link, we’ll send a verification email to your inbox. Open that email and click the verification link inside to complete the process.

                </span>
            </div>
        </FullScreenOverlay>

    );
}

export default InActiveUser;